(function () {
  const COD_API = '/apps/cod/create';
  const PHONE_ERROR =
    'رقم هاتف تونسي غير صحيح. استعمل 8 أرقام (مثال: 22 222 222).';

  const FIELD_MESSAGES = {
    name: 'أدخل اسمك.',
    phone: PHONE_ERROR,
    ville: 'اختر ولايتك.',
    address: 'أدخل عنوانك (5 أحرف على الأقل).',
    email: 'أدخل بريدًا إلكترونيًا صحيحًا.',
  };

  function formatPhoneInput(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length > 8) digits = digits.slice(1);
    digits = digits.slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const text = Number.isInteger(amount) ? String(amount) : amount.toFixed(3);
    return `${text} DT`;
  }

  function normalizeTunisiaPhone(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length === 9) digits = digits.slice(1);
    if (digits.length !== 8 || !/^[234579]\d{7}$/.test(digits)) return null;
    return digits;
  }

  function formatTunisiaPhone(digits) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function splitName(fullName) {
    const parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return { prenom: '', nom: '' };
    if (parts.length === 1) return { prenom: parts[0], nom: parts[0] };
    return { prenom: parts[0], nom: parts.slice(1).join(' ') };
  }

  function getRoot(el) {
    return el.closest('[data-product-cod-checkout]');
  }

  function getForm(root) {
    return root?.querySelector('[data-quick-order-form]');
  }

  function readFields(form) {
    const name = form.querySelector('[data-quick-order-field="name"]')?.value.trim() || '';
    const { prenom, nom } = splitName(name);
    return {
      name,
      prenom,
      nom,
      phone: form.querySelector('[data-quick-order-field="phone"]')?.value.trim() || '',
      email: form.querySelector('[data-quick-order-field="email"]')?.value.trim() || '',
      address: form.querySelector('[data-quick-order-field="address"]')?.value.trim() || '',
      ville: form.querySelector('[data-quick-order-field="ville"]')?.value.trim() || '',
    };
  }

  function showGlobalError(form, message) {
    const el = form.querySelector('[data-quick-order-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setFieldError(form, fieldKey, message) {
    const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
    const errEl = form.querySelector(`[data-field-error="${fieldKey}"]`);
    const input = form.querySelector(`[data-quick-order-field="${fieldKey}"]`);

    if (errEl) {
      errEl.textContent = message || '';
      errEl.hidden = !message;
    }
    if (wrap) wrap.classList.toggle('product-cod-form__field--error', Boolean(message));
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function clearFieldErrors(form) {
    ['name', 'phone', 'ville', 'address', 'email'].forEach((key) => {
      setFieldError(form, key, '');
    });
  }

  function validateField(fieldKey, fields) {
    switch (fieldKey) {
      case 'name':
        if (!fields.name || fields.name.length < 2) return FIELD_MESSAGES.name;
        return null;
      case 'phone':
        if (!normalizeTunisiaPhone(fields.phone)) return FIELD_MESSAGES.phone;
        return null;
      case 'ville':
        if (!fields.ville) return FIELD_MESSAGES.ville;
        return null;
      case 'address':
        if (!fields.address || fields.address.length < 5) return FIELD_MESSAGES.address;
        return null;
      case 'email':
        if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
          return FIELD_MESSAGES.email;
        }
        return null;
      default:
        return null;
    }
  }

  function validateAll(form) {
    const fields = readFields(form);
    let firstErrorKey = null;

    ['name', 'phone', 'ville', 'address', 'email'].forEach((key) => {
      const message = validateField(key, fields);
      setFieldError(form, key, message);
      if (message && !firstErrorKey) firstErrorKey = key;
    });

    if (firstErrorKey) {
      showGlobalError(form, 'يرجى تصحيح الحقول المحددة باللون الأحمر أعلاه.');
      const wrap = form.querySelector(`[data-cod-field="${firstErrorKey}"]`);
      wrap?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return false;
    }

    showGlobalError(form, '');
    return true;
  }

  function getQuantity(root) {
    const qtyInput = root.querySelector('[data-input-quantity], input[name="quantity"]');
    return Math.max(1, parseInt(qtyInput?.value, 10) || 1);
  }

  function getVariantId(root) {
    return root.querySelector('input[name="id"]')?.value;
  }

  function shippingFee(root, subtotal) {
    const fee = Number(root.dataset.shippingFee) || 800;
    const min = Number(root.dataset.freeShippingMin) || 20000;
    return subtotal >= min ? 0 : fee;
  }

  function updateSummary(root) {
    const variantPrice = Number(root.dataset.variantPrice) || 0;
    const qty = getQuantity(root);
    const subtotal = variantPrice * qty;
    const ship = shippingFee(root, subtotal);
    const total = subtotal + ship;

    const subEl = root.querySelector('[data-product-cod-subtotal]');
    const shipEl = root.querySelector('[data-product-cod-shipping]');
    const totalEl = root.querySelector('[data-product-cod-total]');

    if (subEl) subEl.textContent = formatMoney(subtotal);
    if (shipEl) shipEl.textContent = ship === 0 ? 'مجاني' : formatMoney(ship);
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  function buildCartPayload(root, variantId, quantity) {
    const variantPrice = Number(root.dataset.variantPrice) || 0;
    const subtotal = variantPrice * quantity;
    return {
      items: [
        {
          variant_id: Number(variantId),
          quantity,
          price: variantPrice,
          line_price: subtotal,
        },
      ],
      item_count: quantity,
      total_price: subtotal,
    };
  }

  function clearCartInBackground() {
    const url = `${window.routes?.cart_url || '/cart'}/clear.js`;
    fetch(url, { method: 'POST', keepalive: true }).catch(() => {});
    if (typeof window.refreshHeaderCartCount === 'function') {
      window.refreshHeaderCartCount().catch(() => {});
    }
  }

  function redirectToConfirmation(root, orderName) {
    const base = root.dataset.confirmationUrl || '/pages/commande-confirmee';
    const params = new URLSearchParams();
    if (orderName) params.set('ref', orderName);
    if (root.dataset.productId) params.set('product_id', root.dataset.productId);
    window.location.href = `${base}?${params.toString()}`;
  }

  function setSubmitLoading(button, loading) {
    const label = button.querySelector('[data-product-cod-submit-text]');
    const loader = button.querySelector('.btn-loader');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (label) label.textContent = 'Création de votre commande…';
      loader?.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (label) label.textContent = 'Commander maintenant';
      loader?.classList.add('hidden');
    }
  }

  async function submitCodOrder(button) {
    const root = getRoot(button);
    const form = getForm(root);
    if (!root || !form) return;

    showGlobalError(form, '');
    if (!validateAll(form)) return;

    const fields = readFields(form);
    const phoneDigits = normalizeTunisiaPhone(fields.phone);
    fields.phone = formatTunisiaPhone(phoneDigits);
    if (!fields.email) fields.email = `client+${phoneDigits}@exceptiones.com`;

    const variantId = getVariantId(root);
    const quantity = getQuantity(root);
    if (!variantId) {
      showGlobalError(form, 'تعذر العثور على هذا الخيار من المنتج.');
      return;
    }

    setSubmitLoading(button, true);

    let redirecting = false;

    try {
      const cart = buildCartPayload(root, variantId, quantity);

      const res = await fetch(COD_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ fields, cart }),
      });

      const payload = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(payload.error || 'تعذر إتمام الطلب حاليًا.');
      }

      redirecting = true;
      clearCartInBackground();
      redirectToConfirmation(root, payload.orderName);
    } catch (e) {
      console.error('[product-cod]', e);
      showGlobalError(
        form,
        e.message ||
          'الخدمة غير متوفرة حاليًا. حاول مجددًا أو تواصل معنا.',
      );
    } finally {
      if (!redirecting) setSubmitLoading(button, false);
    }
  }

  function bindFieldValidation(root) {
    const form = getForm(root);
    if (!form) return;

    form.querySelectorAll('[data-quick-order-field]').forEach((input) => {
      const fieldKey = input.dataset.quickOrderField;
      if (!fieldKey) return;

      const validateOne = () => {
        const fields = readFields(form);
        const message = validateField(fieldKey, fields);
        if (!message) {
          setFieldError(form, fieldKey, '');
          return;
        }
        if (fieldKey === 'email' && !fields.email) {
          setFieldError(form, fieldKey, '');
          return;
        }
        setFieldError(form, fieldKey, message);
      };

      input.addEventListener('blur', validateOne);
      input.addEventListener('input', () => {
        const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
        if (wrap?.classList.contains('product-cod-form__field--error')) {
          validateOne();
        }
      });
      input.addEventListener('change', validateOne);
    });
  }

  function bindCheckout(root) {
    updateSummary(root);
    bindPhoneInput(root);
    bindFieldValidation(root);

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-input-quantity], input[name="quantity"]')) {
        updateSummary(root);
      }
    });

    root.addEventListener('input', (event) => {
      if (event.target.matches('[data-input-quantity], input[name="quantity"]')) {
        updateSummary(root);
      }
    });
  }

  function bindPhoneInput(root) {
    const phone = root.querySelector('[data-quick-order-field="phone"]');
    if (!phone) return;

    const formatField = () => {
      const formatted = formatPhoneInput(phone.value);
      if (formatted !== phone.value) {
        phone.value = formatted;
        phone.setSelectionRange(formatted.length, formatted.length);
      }
    };

    phone.addEventListener('input', formatField);
    phone.addEventListener('blur', () => {
      const digits = normalizeTunisiaPhone(phone.value);
      phone.value = digits ? formatTunisiaPhone(digits) : formatPhoneInput(phone.value);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-cod-submit]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    submitCodOrder(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-cod-checkout]').forEach(bindCheckout);
  });

  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
    const root = input.closest('[data-product-cod-checkout]');
    if (!root || !input.value) return;
    try {
      const res = await fetch(`/variants/${input.value}.js`);
      const variant = await res.json();
      root.dataset.variantPrice = String(variant.price);
      updateSummary(root);
    } catch (e) {
      console.warn('product-cod variant', e);
    }
  });
})();
